<template>
  <section class="settings-section">
    <div class="settings-container">
      <h2 class="settings-title">系统配置与多终端试用</h2>
      <p class="settings-subtitle">2节点账号试点建设，支持全平台无缝体验</p>
      
      <div class="settings-content">
        <div class="trial-badge">试点版</div>
        
        <div class="settings-features">
          <div v-for="feature in settingsFeatures" :key="feature.text" class="settings-feature">
            <div class="settings-feature-icon">{{ feature.icon }}</div>
            <div class="settings-feature-text">{{ feature.text }}</div>
          </div>
        </div>

        <div class="settings-cta">
          <button class="settings-button" @click="openSettings">
            <span class="settings-button-icon">⚙️</span>
            <span>进入系统配置</span>
          </button>
          
          <div class="contact-info">
            <div class="contact-icon">🎓</div>
            <div class="contact-text">
              <div class="contact-title">试点建设技术支持</div>
              <div class="contact-id">CONSTRUCTION_KG_V1</div>
              <div class="contact-desc">
                专业技术团队提供7×24小时支持<br>
                建筑工程技术及钢结构专业定制化服务
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SystemConfig',
  data() {
    return {
      settingsFeatures: [
        { icon: '🌐', text: 'Chrome/Firefox/Safari/Edge全兼容' },
        { icon: '📱', text: '移动端浏览器完整功能支持' },
        { icon: '🔧', text: '个性化参数配置与调整' },
        { icon: '🛡️', text: '专业级权限管理与数据安全' }
      ]
    }
  },
  methods: {
    openSettings() {
      alert('系统配置界面\n\n配置选项包括：\n\n🌐 多终端适配设置\n📊 数据同步参数\n🔒 权限管理配置\n🎨 界面个性化\n🔧 性能优化选项\n📱 移动端适配\n\n当前状态：2节点在线\n支持平台：Chrome, Firefox, Safari, Edge')
    }
  }
}
</script>

<style scoped>
/* 系统配置部分 */
.settings-section {
  background: linear-gradient(135deg, #4682B4 0%, #2E5CE6 50%, #FF6B35 100%);
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

.settings-section::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: float-element 30s infinite linear;
}

.settings-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
  position: relative;
  z-index: 1;
}

.settings-title {
  font-size: 48px;
  font-weight: 800;
  color: white;
  margin-bottom: 24px;
  letter-spacing: -0.02em;
}

.settings-subtitle {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 48px;
  font-weight: 500;
}

.settings-content {
  background: white;
  border-radius: 32px;
  padding: 60px;
  max-width: 800px;
  margin: 0 auto;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.2);
  position: relative;
}

.trial-badge {
  position: absolute;
  top: -20px;
  right: 40px;
  background: #10B981;
  color: white;
  padding: 8px 24px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 16px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.settings-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 48px;
}

.settings-feature {
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
}

.settings-feature-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #60A5FA 0%, #FF6B35 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
}

.settings-feature-text {
  font-size: 16px;
  color: #111827;
  font-weight: 500;
}

.settings-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.settings-button {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #2E5CE6 0%, #FF6B35 100%);
  color: white;
  padding: 20px 48px;
  border-radius: 100px;
  font-size: 20px;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(46, 92, 230, 0.3);
  border: none;
  cursor: pointer;
}

.settings-button:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(46, 92, 230, 0.4);
}

.settings-button-icon {
  font-size: 24px;
}

.contact-info {
  background: #F9FAFB;
  border-radius: 24px;
  padding: 32px;
  display: flex;
  align-items: center;
  gap: 32px;
  margin-top: 32px;
}

.contact-icon {
  width: 120px;
  height: 120px;
  background: white;
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 48px;
}

.contact-text {
  flex: 1;
  text-align: left;
}

.contact-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
}

.contact-id {
  font-size: 24px;
  font-weight: 700;
  color: #2E5CE6;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.contact-desc {
  font-size: 16px;
  color: #6B7280;
  line-height: 1.6;
}

@keyframes float-element {
  0% {
    transform: translateY(100vh) rotate(0deg);
  }
  100% {
    transform: translateY(-100px) rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .settings-content {
    padding: 40px 24px;
  }

  .settings-features {
    grid-template-columns: 1fr;
  }

  .contact-info {
    flex-direction: column;
    text-align: center;
  }

  .contact-text {
    text-align: center;
  }

  .settings-title {
    font-size: 32px;
  }

  .settings-subtitle {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .settings-button {
    font-size: 18px;
    padding: 16px 32px;
  }
}
</style>